import { render, staticRenderFns } from "./CardEditPopUp.vue?vue&type=template&id=14fa28dc&scoped=true"
import script from "./CardEditPopUp.vue?vue&type=script&lang=js"
export * from "./CardEditPopUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fa28dc",
  null
  
)

export default component.exports